const EXTERNAL_LINK_SELECTOR = "a[href]";
const WHITELIST_LINK_SELECTORS = [
  ".comp-subscription__link",
  ".button-subscriptions",
];

function isExternalHttpUrl(url) {
  return (
    (url.protocol === "http:" || url.protocol === "https:") &&
    url.origin !== window.location.origin
  );
}

function isAuth0Url(url) {
  return url.hostname.toLowerCase().includes("auth0");
}

function shouldSkipLink(link, url) {
  const isWhitelistLink = WHITELIST_LINK_SELECTORS.some((selector) =>
    link.matches(selector),
  );
  if (isWhitelistLink) return true;
  if (link.hasAttribute("data-external-new-tab-disabled")) return true;
  if (link.hasAttribute("download")) return true;
  if (link.target && link.target !== "" && link.target !== "_self") return true;
  if (!isExternalHttpUrl(url)) return true;
  if (isAuth0Url(url)) return true;
  return false;
}

function applyExternalLinkBehavior(scope = document) {
  const links = scope.querySelectorAll(EXTERNAL_LINK_SELECTOR);

  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) return;

    let parsedUrl;
    try {
      parsedUrl = new URL(href, window.location.origin);
    } catch {
      return;
    }

    if (shouldSkipLink(link, parsedUrl)) return;

    link.target = "_blank";

    const relValues = new Set(
      (link.getAttribute("rel") || "")
        .split(/\s+/)
        .filter(Boolean)
        .map((value) => value.toLowerCase()),
    );

    relValues.add("noopener");
    relValues.add("noreferrer");
    link.setAttribute("rel", [...relValues].join(" "));
  });
}

applyExternalLinkBehavior();

document.addEventListener("shopify:section:load", (event) => {
  applyExternalLinkBehavior(event.target);
});
